import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";

import { ExpandedTable } from "@ryde/controls";

import { BulkPreviewStepUploadConflictsContext } from "../../bulk-preview-step-upload-conflicts.context";
import { RejectedBookingUploadExpanded } from "./rejected-bookings-upload-expanded";
import { RejectedBookingsUploadRow } from "./rejected-bookings-upload-row";

export const RejectedBookingsUpload: FC = () => {
  const { conflicts } = useContext(BulkPreviewStepUploadConflictsContext);
  const { t } = useTranslation();

  return (
    <RejectedBookingUploadExpanded>
      <ExpandedTable dataE2E="rejected-bookings-upload-table">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{t("general.index")}</TableCell>
              <TableCell>{t("booking.bulk.passengerCode")}</TableCell>
              <TableCell>{t("booking.bulk.date")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {conflicts?.map(conflictRow => (
              <RejectedBookingsUploadRow
                key={`${conflictRow.passengerCode}_${conflictRow.index}`}
                conflictRow={conflictRow}
              />
            ))}
          </TableBody>
        </Table>
      </ExpandedTable>
    </RejectedBookingUploadExpanded>
  );
};
